export interface JsonThemaChannelGoal {
    channelCode: string;
    year: number;
    goal: number;
}

export class ThemaChannelGoal {
    channelCode: string;
    year: number;
    goal: number;

    constructor(jsonContractPackChannel: JsonThemaChannelGoal = null) {
        this.channelCode = jsonContractPackChannel?.channelCode;
        this.year = jsonContractPackChannel?.year;
        this.goal = jsonContractPackChannel?.goal;
    }
}
